import avatarDefault from '@/assets/images/pngs/avatar-default.png';
import QRDefault from '@/assets/images/pngs/qr-profile.png';
import Header from '@/components/layout/Header';
import { ROUTES } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import coppyIconSvg from '@/assets/images/svgs/coppy-icon.svg';

export default observer(function QRProfilePage() {
    // store
    const {
        authStore: { profile }
    } = useStore();
    const navigate = useNavigate();

    const goBack = () => {
        navigate(ROUTES.profile.href);
    };

    const handleCoppyWallet = () => {
        console.log('object');
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header goBackFunction={goBack} title={t('text.myQr')} />
            <div className='px-[1.65625rem] mt-[4rem]'>
                <div className='w-full aspect-square rounded-[20px] bg-gradient-to-r from-[#D9FEDE] to-[#F1F8E6] relative'>
                    {/* <div className='w-[80px] h-[80px] rounded-full absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                        <img src={avatarDefault} alt='avatar' className='w-[80px] h-[80px]' />
                    </div> */}
                    {/* <div className='flex items-center justify-center'>
                        <div className='size-[178px] mt-[60px]'>QR code here!!!</div>
                        <div>ただいま準備中です。しばらくお待ちください。</div>
                    </div> */}
                    <div className='absolute inset-0 flex flex-col items-center justify-center'>
                        <p className='text-[15px] font-semibold text-black break-words px-4 text-center'>
                            {profile?.username}
                        </p>
                    </div>
                    {/* <p className='text-[15px] font-semibold text-center text-black mt-[26px] break-words px-4'>{profile?.username}</p> */}
                    <div className='text-[13px] text-center text-text mt-1 flex items-center justify-center space-x-1'>
                        {/* <span>ウォレットアドレスをコピー</span>
                        <button onClick={handleCoppyWallet} className='size-5'>
                            <img className='w-full h-full' src={coppyIconSvg} alt='' />
                        </button> */}
                    </div>

                </div>
            </div>

        </div>
    );
});
